import { useMemo } from 'react';

import { getAppPageConfig } from 'hb-react/frontoffice/utils/page';
import { useTopicMenu } from 'hb-react/shared/apps/Topics/hooks/useTopicMenu';
import useFetchAppPages from 'hb-react/shared/hooks/useFetchAppPages';

export const useConfig = ({ topic, routes }) => {
  const isInTopic = !!topic?.id;
  const globalPages = useFetchAppPages({ enabled: !isInTopic });
  const { appPages: topicPages } = useTopicMenu({
    topic,
    enabled: isInTopic,
  });
  const appPages = isInTopic ? topicPages : globalPages;

  const appPageConfig = appPages
    ? getAppPageConfig('mentorships', null, appPages)
    : undefined;

  const config = useMemo(
    () => ({
      custom: {
        page: appPageConfig,
      },
      routes,
      topic,
    }),
    [appPageConfig, routes, topic],
  );

  return { appPages, config };
};
